import helper from './helper';
import CountUp from 'countup.js';
import jsForm from './ajax/js-form.js';
import checkValidity from './form-validation/check-validity';

class OrderConfirmation {
    constructor() {
        this.checkValidity = checkValidity;
        this.formIsValid = false;
        this.form = $('form.shop-order-confirmation');
        this.fieldTotal = this.form.find('#total');
        this.orderSummary = this.fieldTotal.length
            ? parseFloat(this.fieldTotal.attr('data-basket').replace(',', '.'))
            : 0;
        this.fieldDelivery = this.form.find('.shop-order-table__delivery');

        let _this = this;

        new jsForm('.shop-order-confirmation');

        this.form.on('change', '[name = deliveryTypeId]', function () {
            _this.checkAddressRequirement();
            return _this.updateTable($(this));
        });

        this.checkAddressRequirement();
    }

    validation($form) {
        if (this.checkValidity($form)) {
            this.formIsValid = true;
            $form.find('[type=submit]').each((index, el) => {
                $(el).prop('disabled', true);
            });
            $form.submit();
        }
    }

    updateTable($input) {
        let animateNumber;
        let cost = parseFloat($input.attr('data-cost').replace(',', '.'));
        let start = parseFloat(
            this.fieldTotal.attr('data-current').replace(',', '.')
        );
        let end = this.orderSummary + cost;
        let fieldDelivertHtml =
            Math.ceil(cost) > 0
                ? helper.formatDecimals(cost) + ' р.'
                : '&mdash;';

        this.fieldDelivery
            .children('.shop-order-table__item-price')
            .html(fieldDelivertHtml);

        this.fieldTotal.attr('data-current', end);

        animateNumber = new CountUp(
            this.fieldTotal[0],
            start,
            end,
            isInt(end) ? 0 : 2,
            0.5,
            {
                separator: ' ',
                decimal: ',',
            }
        );
        animateNumber.start();
    }

    checkAddressRequirement() {
        let sekectedDeliveryType = this.form.find(
            '[name=deliveryTypeId]:checked'
        );
        let addressField = this.form.find('[name=address]');
        if (sekectedDeliveryType.data('requireAddress')) {
            addressField.attr('required', true);
        } else {
            addressField.attr('required', false);
            if (
                !addressField.val() &&
                addressField.hasClass('sst-field--has-error')
            ) {
                addressField.removeClass('sst-field--has-error');
            }
        }
    }
}

function isInt(n) {
    return Number(n) === n && n % 1 === 0;
}

export const orderConfirmation = new OrderConfirmation();
